import { createLogic } from 'redux-logic';
import {
    formFinderConfigLoad,
    formFinderConfigLoaded,
    finderUpdateSections,
    finderUpdatedSections,
    finderChangeStep,
    formFinderSave,
    formFinderSaved,
    formFinderSaveAndRedirect,
    formFinderDelete,
    formFindersLoadExisting,
    formFinderDiscardChanges,
} from '../actions';
import { apiGet, apiPost, apiDelete } from '../api';
import { push } from 'connected-react-router';

const getForms = async (token) => {
    const result = await apiGet('/forms', token);

    return result.data;
};

const loadFormFinderConfig = createLogic({
    type: formFinderConfigLoad,
    latest: true,
    warnTimeout: 0,
    processOptions: {
        dispatchMultiple: true,
    },
    async process({ getState, action }, dispatch, done) {
        const authContext = getState().authentication;
        let formFinder;

        if (action.payload) {
            const token = await authContext.getAccessToken(authContext.authorizationScopes.formFinders);
            const response = await apiGet(`/formFinders/${action.payload}`, token);

            formFinder = response.data;
        } else {
            formFinder = {
                name: 'Form Finder',
                steps: {},
                firstStep: '0',
            };
        }

        const steps = Object.keys(formFinder.steps).map((i) => formFinder.steps[i]);
        const activeStep = steps.length > 0 ? 0 : -1;

        const token = await authContext.getAccessToken(authContext.authorizationScopes.forms);
        const forms = await getForms(token);

        dispatch(
            formFinderConfigLoaded({
                formFinder,
                steps,
                activeStep,
                forms,
                lastSavedFinder: formFinder,
            }),
        );

        done();
    },
});

const updateFormFinderSteps = createLogic({
    type: finderUpdateSections,
    latest: true,
    warnTimeout: 0,
    processOptions: {
        dispatchMultiple: true,
    },
    process({ getState, action }, dispatch) {
        let newSteps = [];
        let currentStep = getState().formFinderBuilder.activeStep;
        const steps = getState().formFinderBuilder.steps;
        if (action.payload.step) {
            newSteps = [
                ...steps.slice(0, action.payload.index),
                action.payload.step,
                ...steps.slice(action.payload.index + 1),
            ];
        } else if (action.payload.type) {
            let step = { text: 'Your text goes here' };
            switch (action.payload.type) {
                case 'question':
                    step = {
                        ...step,
                        choices: [{ choice: 'Choice 1' }, { choice: 'Choice 2' }],
                    };
                    break;
                case 'form':
                    step = {
                        ...step,
                        form: -1,
                    };
                    break;
                default:
                    break;
            }
            newSteps = [...steps.slice(0, action.payload.index), step, ...steps.slice(action.payload.index)];
            currentStep = currentStep + 1;
        } else {
            newSteps = steps.filter((step, index) => index !== action.payload.index);
            currentStep = currentStep === steps.length - 1 ? currentStep - 1 : currentStep;
        }

        const noSteps = steps.length < 1;
        const deletedNotLast = newSteps.length < steps.length && newSteps.length !== 0;

        (noSteps || deletedNotLast) && dispatch(finderChangeStep(currentStep));
        dispatch(finderUpdatedSections(newSteps));
        !noSteps && dispatch(finderChangeStep(currentStep));
    },
});

const saveFormFinder = createLogic({
    type: formFinderSave,
    latest: true,
    async process({ getState, action }, dispatch, done) {
        const formFinder = {
            ...getState().formFinderBuilder.formFinder,
            steps: Object.assign({}, getState().formFinderBuilder.steps),
        };

        const authContext = getState().authentication;
        const token = await authContext.getAccessToken(authContext.authorizationScopes.formFinders);

        saveFormFinderData(formFinder, token)
            .then((result) => {
                if (result.data && result.data.id) {
                    if (!formFinder.id) {
                        formFinder.id = result.data.id;
                    }
                }
                dispatch(formFinderSaved(formFinder));
                action.payload.callBack('success');
            })
            .catch(() => {
                action.payload.callBack('error');
            })
            .finally(done);
    },
});

const saveFormFinderWithRedirection = createLogic({
    type: formFinderSaveAndRedirect,
    latest: true,
    async process({ getState, action }, dispatch, done) {
        const formFinder = {
            ...getState().formFinderBuilder.formFinder,
            steps: Object.assign({}, getState().formFinderBuilder.steps),
        };

        const authContext = getState().authentication;
        const token = await authContext.getAccessToken(authContext.authorizationScopes.formFinders);

        saveFormFinderData(formFinder, token)
            .then((result) => {
                if (result.data && result.data.id) {
                    if (!formFinder.id) {
                        formFinder.id = result.data.id;
                    }
                }
                dispatch(formFinderSaved(formFinder));
                action.payload.callBack('success');
                dispatch(push('/'));
            })
            .catch(() => {
                action.payload.callBack('error');
            })
            .finally(done);
    },
});

const discardFormFinderChanges = createLogic({
    type: formFinderDiscardChanges,
    latest: true,
    warnTimeout: 0,
    async process({ getState }, dispatch, done) {
        const formFinder = {
            ...getState().formFinderBuilder.lastFormFinder,
            steps: Object.assign({}, getState().formFinderBuilder.steps),
        };

        dispatch(formFinderSaved(formFinder));
        dispatch(push('/'));
        done();
    },
});

const deleteFormFinder = createLogic({
    type: formFinderDelete,
    latest: true,
    async process({ getState, action }, dispatch, done) {
        const formFinder = action.payload;
        const authContext = getState().authentication;
        const token = await authContext.getAccessToken(authContext.authorizationScopes.formFinders);

        apiDelete(`/formFinders/${formFinder.id}`, token)
            .then(() => {
                dispatch(formFindersLoadExisting());
            })
            .catch(() => {})
            .finally(done);
    },
});

async function saveFormFinderData(formFinder, token) {
    return apiPost('/formFinders', formFinder, token);
}
export default [
    loadFormFinderConfig,
    updateFormFinderSteps,
    saveFormFinder,
    saveFormFinderWithRedirection,
    deleteFormFinder,
    discardFormFinderChanges,
];
